var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnGoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "on-going") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "on-going",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "#4085FD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10.9,10.4876953 L10.9,5.5 C10.9,5.00294373 10.4970563,4.6 10,4.6 C9.50294373,4.6 9.1,5.00294373 9.1,5.5 L9.1,11.3876953 C9.1,11.8847516 9.50294373,12.2876953 10,12.2876953 L14.6237793,12.2876953 C15.1208356,12.2876953 15.5237793,11.8847516 15.5237793,11.3876953 C15.5237793,10.890639 15.1208356,10.4876953 14.6237793,10.4876953 L10.9,10.4876953 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnGoing);
export default __webpack_public_path__ + "static/media/on-going.798645f9ef80e1aa4e359bd9a597dbb0.svg";
export { ForwardRef as ReactComponent };